import { DateTime } from 'luxon';

export interface PracticeHour {
  day: number; // 0 = Sunday, 6 = Saturday
  openingTime: string; // "08:00"
  closingTime: string; // "17:00"
  isClosed: boolean;
}

export function isTimeWithinOperationalHours(
  time24h: string,                // e.g., "14:30"
  timezoneText: string,          // e.g., "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi"
  practiceOperationalHours: PracticeHour[],
  timezones: any[]               // from timezones.json
): boolean {
  // Validate input time format
  const [hourStr, minuteStr] = time24h.split(':');
  if (!hourStr || !minuteStr) {
    return false;
  }

  const hour = parseInt(hourStr, 10);
  const minute = parseInt(minuteStr, 10);

  if (isNaN(hour) || isNaN(minute) || hour > 23 || minute > 59) {
    return false;
  }

  // Get IANA timezone
  const tzEntry = timezones.find(tz => tz.text === timezoneText);
  const ianaTimezone = tzEntry?.utc?.[0];

  if (!ianaTimezone) {
    return false;
  }

  // Current time in target timezone
  const nowInTZ = DateTime.now().setZone(ianaTimezone);
  const dateTimeInTZ = nowInTZ.set({ hour, minute, second: 0 });
  const dayOfWeek = dateTimeInTZ.weekday % 7; // 0 = Sunday

  const todayHours = practiceOperationalHours.find(h => h.day === dayOfWeek);

  // Defensive checks for time format
  if (!todayHours.openingTime || !todayHours.closingTime) {
    return false;
  }

  const [openHour, openMin] = todayHours.openingTime.split(':').map(Number);
  const [closeHour, closeMin] = todayHours.closingTime.split(':').map(Number);

  if (
    isNaN(openHour) || isNaN(openMin) ||
    isNaN(closeHour) || isNaN(closeMin)
  ) {
    return false;
  }

  const openDateTime = dateTimeInTZ.set({ hour: openHour, minute: openMin });
  const closeDateTime = dateTimeInTZ.set({ hour: closeHour, minute: closeMin });

  return dateTimeInTZ >= openDateTime && dateTimeInTZ <= closeDateTime;
}

